var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 210",
    style: {
      enableBackground: "new 0 0 290 210"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.1;fill:#51BFFF;enable-background:new    ;}\r\n\t.st1{fill:#FFFFFF;stroke:#52BFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#52BFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.4;}\r\n\t.st4{fill:none;stroke:#51BFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.5;fill:#51BFFF;enable-background:new    ;}\r\n\t.st6{opacity:0.2;fill:#51BFFF;enable-background:new    ;}\r\n\t.st7{fill:#52BFFF;}\r\n\t.st8{fill:#51BFFF;}\r\n\t.st9{opacity:0.4;fill:#51BFFF;enable-background:new    ;}\r\n\t.st10{opacity:0.3;fill:#51BFFF;enable-background:new    ;}\r\n\t.st11{opacity:0.2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 145,
    cy: 105,
    r: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,44l-2.1-5.8c-0.3-0.9-1.1-1.6-2.1-1.7L206,34.9c-1.3-0.1-2.5,0.8-2.7,2.2l-3.7,35.5 c-0.1,1.3,0.8,2.5,2.2,2.7l50,5.2c1.3,0.1,2.5-0.8,2.7-2.2l2.8-27.1c0.1-1.3-0.8-2.5-2.2-2.7l-28.2-2.9 C225.9,45.5,225.1,44.9,224.8,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,39.5l-1.3-6.1c-0.2-0.9-0.9-1.7-1.8-1.9L220.1,28c-1.3-0.3-2.6,0.5-2.9,1.8l-8.5,34.7 c-0.3,1.3,0.5,2.6,1.8,2.9l48.8,11.9c1.3,0.3,2.6-0.5,2.9-1.8l6.5-26.5c0.3-1.3-0.5-2.6-1.8-2.9l-27.5-6.7 C238.4,41.2,237.7,40.4,237.6,39.5z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 5,
    y1: 179.2,
    x2: 285,
    y2: 179.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,34.4c2.7-1.1,5.7,0.2,6.8,2.9l21.4,53.4c1.1,2.7-0.2,5.7-2.9,6.8l-38.9,15.6c-2.7,1.1-5.7-0.2-6.8-2.9 L8.6,56.8c-1.1-2.7,0.2-5.7,2.9-6.8L50.4,34.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8,34.8L65,26.7c2.8-0.7,5.6,1,6.4,3.8l14,55.8c0.7,2.8-1,5.6-3.8,6.4L41,102.8c-2.8,0.7-5.6-1-6.4-3.8 l-12-47.9c-0.4-1.4-0.1-2.9,0.7-4.1l6.4-10C30.4,35.9,31.5,35.1,32.8,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.9,38.3l1.5,5.8c0.6,2.4-0.9,4.8-3.3,5.4L27.3,51"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 42.6,
    y1: 56.6,
    x2: 68,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 33.7,
    y1: 58.8,
    x2: 36.2,
    y2: 58.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 44.5,
    y1: 64.2,
    x2: 69.9,
    y2: 57.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 35.6,
    y1: 66.4,
    x2: 38.1,
    y2: 65.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 46.4,
    y1: 71.8,
    x2: 71.8,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 37.5,
    y1: 74,
    x2: 40.1,
    y2: 73.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 48.3,
    y1: 79.4,
    x2: 73.7,
    y2: 73.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 39.4,
    y1: 81.7,
    x2: 42,
    y2: 81
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 50.2,
    y1: 87,
    x2: 75.6,
    y2: 80.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 41.3,
    y1: 89.3,
    x2: 43.9,
    y2: 88.6
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 33.1,
    cy: 140.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 129.6,
    cy: 29.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 255.6,
    cy: 100.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 152.6,
    cy: 37.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 36.6,
    cy: 158.5,
    r: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226,161.8H64c-2.2,0-4-1.8-4-4V52.5c0-2.2,1.8-4,4-4h162c2.2,0,4,1.8,4,4v105.3 C230,160,228.2,161.8,226,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.3,143.9H68.7c-2.2,0-4-1.8-4-4V57.2c0-2.2,1.8-4,4-4h152.6c2.2,0,4,1.8,4,4v82.7 C225.3,142.1,223.5,143.9,221.3,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.4,178.8h-42.7c-1.5,0-2.7-1.2-2.7-2.7v-0.2c0-1.5,1.2-2.7,2.7-2.7h42.7c1.5,0,2.7,1.2,2.7,2.7v0.2 C169.1,177.6,167.9,178.8,166.4,178.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.7,
    y: 161.8,
    className: "st1",
    width: 22.7,
    height: 11.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.8,
    y1: 67.4,
    x2: 224.4,
    y2: 67.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 72.8,
    cy: 60.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 80.4,
    cy: 60.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 145,
    cy: 152.4,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 88,
    cy: 60.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.9,101.6H81.6c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C98.7,100.7,97.9,101.6,96.9,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.6,101.6h-15.3c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C121.4,100.7,120.6,101.6,119.6,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.4,101.6H127c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h81.4c1,0,1.8,0.8,1.8,1.8v0.2 C210.2,100.7,209.4,101.6,208.4,101.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.9,114.8H81.6c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C98.7,114,97.9,114.8,96.9,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.6,114.8h-15.3c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C121.4,114,120.6,114.8,119.6,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.4,114.8H127c-1,0-1.8-0.8-1.8-1.8v-0.2c0-1,0.8-1.8,1.8-1.8h81.4c1,0,1.8,0.8,1.8,1.8v0.2 C210.2,114,209.4,114.8,208.4,114.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.9,128H81.6c-1,0-1.8-0.8-1.8-1.8V126c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C98.7,127.2,97.9,128,96.9,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.6,128h-15.3c-1,0-1.8-0.8-1.8-1.8V126c0-1,0.8-1.8,1.8-1.8h15.3c1,0,1.8,0.8,1.8,1.8v0.2 C121.4,127.2,120.6,128,119.6,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.4,128H127c-1,0-1.8-0.8-1.8-1.8V126c0-1,0.8-1.8,1.8-1.8h81.4c1,0,1.8,0.8,1.8,1.8v0.2 C210.2,127.2,209.4,128,208.4,128z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 92.7,
    cy: 162.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.8,88.5h-28c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v4C111.8,87.6,110.9,88.5,109.8,88.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.2,88.5h-56c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h56c1.1,0,2,0.9,2,2v4C210.2,87.6,209.3,88.5,208.2,88.5 z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 246.6,
    cy: 130.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 8.1,
    cy: 113.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 273.6,
    cy: 107.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 159.6,
    cy: 18.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 17.6,
    cy: 164.5,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 121.5,
    className: "st8",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 123.8,
    className: "st8",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 172.5,
    className: "st8",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 174.8,
    className: "st8",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.9,
    y: 25.5,
    className: "st8",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.6,
    y: 27.8,
    className: "st8",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 114.5,
    className: "st8",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 116.8,
    className: "st8",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.9,
    y: 174.5,
    className: "st8",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.6,
    y: 176.8,
    className: "st8",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 141,
    className: "st1",
    width: 42,
    height: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.6,143.8H35.1c-2.2,0-4-1.8-4-4v-4.6c0-2.2,1.8-4,4-4h44.5c2.2,0,4,1.8,4,4v4.6 C83.6,142,81.8,143.8,79.6,143.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 36.3,
    y1: 134.9,
    x2: 36.3,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.6,
    y1: 134.9,
    x2: 41.6,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.8,
    y1: 134.9,
    x2: 46.8,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 52.1,
    y1: 134.9,
    x2: 52.1,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 57.3,
    y1: 134.9,
    x2: 57.3,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62.6,
    y1: 134.9,
    x2: 62.6,
    y2: 140.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 75.7,
    cy: 137.5,
    r: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.6,161.6H35.1c-2.2,0-4-1.8-4-4V153c0-2.2,1.8-4,4-4h44.5c2.2,0,4,1.8,4,4v4.6 C83.6,159.9,81.8,161.6,79.6,161.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 36.3,
    y1: 152.7,
    x2: 36.3,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.6,
    y1: 152.7,
    x2: 41.6,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.8,
    y1: 152.7,
    x2: 46.8,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 52.1,
    y1: 152.7,
    x2: 52.1,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 57.3,
    y1: 152.7,
    x2: 57.3,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62.6,
    y1: 152.7,
    x2: 62.6,
    y2: 158
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 75.7,
    cy: 155.3,
    r: 2.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.6,179.5H35.1c-2.2,0-4-1.8-4-4v-4.6c0-2.2,1.8-4,4-4h44.5c2.2,0,4,1.8,4,4v4.6 C83.6,177.7,81.8,179.5,79.6,179.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 36.3,
    y1: 170.6,
    x2: 36.3,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.6,
    y1: 170.6,
    x2: 41.6,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.8,
    y1: 170.6,
    x2: 46.8,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 52.1,
    y1: 170.6,
    x2: 52.1,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 57.3,
    y1: 170.6,
    x2: 57.3,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62.6,
    y1: 170.6,
    x2: 62.6,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 75.7,
    cy: 173.2,
    r: 2.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 222.6,
    cy: 148.5,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.6,140.7c0.2,0.3,0.4,0.7,0.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.5,138.4c5.4-5.4,14-5.6,19.7-0.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 235.3,
    y1: 161.2,
    x2: 237.4,
    y2: 163.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.6,177.5L251.6,177.5c-1.4,1.4-3.6,1.4-4.9,0l-8.5-8.5c-1.4-1.4-1.4-3.6,0-4.9l0,0c1.4-1.4,3.6-1.4,4.9,0 l8.5,8.5C252.9,173.9,252.9,176.1,251.6,177.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 239.9,
    y1: 170.8,
    x2: 244.9,
    y2: 165.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoData);
export default __webpack_public_path__ + "static/media/img_noData.daead957fff7b53e1b5de5d195fb4d28.svg";
export { ForwardRef as ReactComponent };